import React from 'react'

const Industriescopy2 = ({content}) => {
  return (
    <div>
        <div className='  row'>
          {content.map((val,i)=>(
            <div className={`col-lg-3 col-md-4 col-6 text-center industry2 ${val.class} ${val.class2} border-min  pt-4 pb-3  `} key={i}>
            <img src={val.icon} alt="" style={{height:50,width:50}} />
            <h4 className='mt-4 h3-heading lh-base text-white fw-semibold pb-3 fs-5 industry3'>{val.title}</h4>
            </div>
        ))}
         </div>
    </div>
  )
}

export default Industriescopy2